import cx from 'classnames';

import { b } from './style.css';

export function FieldErrorBox(props: FieldErrorBox.Props) {
    return <div className={cx(b.name, props.className)}>{props.children}</div>;
}

export namespace FieldErrorBox {
    export interface Props {
        className?: string;
        children?: React.ReactNode;
    }
}
